import { Flex, Form, Input, notification } from 'antd'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DownloadWhiteIcon from 'src/assets/images/download-white.png'

import './index.scss'
import { FormValues } from './type'
import { IGetFileDetailResponse } from 'src/app/shared/models/Transaction.model'
import { saveAs } from 'file-saver'

interface IUploadFileData {
  control: Control<FormValues>
  errors: any
  data: IGetFileDetailResponse
}
const UploadFileData = (props: IUploadFileData) => {
  const { data } = props
  const { t } = useTranslation()
  const [api, contextHolder] = notification.useNotification()

  const handleSaveFile = async () => {
    try {
      const res = await fetch(data.fileUrl)
      if (res.ok) {
        const buffer = await res.arrayBuffer()
        const blob = new Blob([new Uint8Array(buffer)])
        saveAs(blob, data.fileName)
      } else {
        api.error({
          message: t('common:download_failed'),
        })
      }
    } catch (error) {}
  }

  return (
    <>
      {contextHolder}
      <Flex justify='space-between' align='center' gap={24} className='row-item'>
        <Form.Item label={t('PurgeTransactions:dateUpload')}>
          <Input className='ant-input-view-only' maxLength={255} disabled readOnly value={data.dateUploaded} />
        </Form.Item>

        <Form.Item label={t('PurgeTransactions:dateProcessed')}>
          <Input className='ant-input-view-only' maxLength={255} disabled readOnly value={data.dateProcessed} />
        </Form.Item>
      </Flex>
      <Flex justify='space-between' align='center' gap={24} className='row-item'>
        <Form.Item label={t('PurgeTransactions:fileName')}>
          <Input
            className='sample-file-upload ant-input-view-only download-tmp'
            suffix={<img src={DownloadWhiteIcon} alt='fileName icon' onClick={handleSaveFile} />}
            readOnly
            disabled
            value={data.fileName}
          />
        </Form.Item>

        <Form.Item label={t('PurgeTransactions:numberOfRecordsToDelete')}>
          <Input className='ant-input-view-only' disabled readOnly value={data.numOfRecords} />
        </Form.Item>
      </Flex>

      <Flex className='row-item-50'>
        <Form.Item label={t('PurgeTransactions:totalAmountForRecordsToDetete')}>
          <Input className='ant-input-view-only' maxLength={255} disabled readOnly value={data.totalAmount} />
        </Form.Item>
      </Flex>
    </>
  )
}

export default UploadFileData
